export enum LogStatus {
  STATUS_START_INSPECTION = 'Inspection started',
  STATUS_END_INSPECTION = 'Inspection completed',
  'STATUS_PRODUCT_STATUS_LOCKED_UNLOCKED' = 'BOX Unlocked / locked',
}

export const STATUS_TAG_CONFIG = {
  ACTIVE: {
    color: '#91D5FF',
    textColor: '#1890FF',
    label: 'Requested',
  },
  USED: {
    color: '#FFE58F',
    textColor: '#FAAD14',
    label: 'Used',
  },
  NOT_REQUESTED: {
    color: '#D9D9D9',
    textColor: '#000000',
    label: 'Not Requested',
  },
} as const;

export type StatusTagType = keyof typeof STATUS_TAG_CONFIG;
